import { FullOffer } from '../offer/offer';

export class BasketList {
  userKey: number;
  offerKey: number[];

  constructor(userKey: number, offerKey: number[]) {
    this.userKey = userKey;
    this.offerKey = offerKey;
  }
}

export class PersoOffer {
  basketOfferKey: number;
  values: string;
  userKey: number;
  memoMessageUser: string;
  cityUser: string;
  postalCodeUser: string;
  licenceUser: string;
  ageUser?: number;
  birthdateUser?: string;
  isComplete: boolean;

}

export class BookBasketOffer {
  userKey: number;
  offerKeys: string[];
  bookedSessionWithPrice: SessionList[];
  phoneNumberUser?: string;
  bookingAmount: number;
  counterUserKey?: number;
  bookingKey?: number;
  memoMessageUser?: string;
  promoCodeDiscount?: number;
  promoCodeName?: string;

  constructor(userKey: number, offerKeys: string[], bookingAmount: number, bookedSessionWithPrice: SessionList[], phoneNumberUser: string = '', counterUserKey?: number, bookingKey?: number) {
    this.userKey = userKey;
    this.offerKeys = offerKeys;
    this.bookedSessionWithPrice = bookedSessionWithPrice;
    this.phoneNumberUser = phoneNumberUser;
    this.bookingAmount = bookingAmount;
    this.counterUserKey = counterUserKey;
    this.bookingKey = bookingKey;
  }
}

export class SessionList {
  sessionBasketKey: number;
  sessionTotalPrice: number;

  constructor(sessionBasketKey: number, sessionTotalPrice: number) {
    this.sessionBasketKey = sessionBasketKey;
    this.sessionTotalPrice = sessionTotalPrice;
  }
}

export class BasketOffer {
  offerKey: number;
  offerBasketKey: number;
  values: string;
  memoMessageUser: string;
  cityUser: string;
  postalCodeUser: string;
  licenceUser: string;
  quantity: number;
  // ageUser: number;
  birthdateUser: string;
  quantityPrice: number;
}

export class BasketOfferDuplicate {
  basketOfferKey: number;
  userKey: number;

  constructor(basketOfferKey: number, userKey: number) {
    this.basketOfferKey = basketOfferKey;
    this.userKey = userKey;
  }
}
export class SelectBasketOffer {
  userKey: number;
  sessionBasketKey: number;
  isSelected: boolean;

  constructor(userKey: number, sessionBasketKey: number, isSelected: boolean = null) {
    this.userKey = userKey;
    this.sessionBasketKey = sessionBasketKey;
    this.isSelected = isSelected;
  }
}
export class BasketWithPrice {
  fullOfferList: FullOffer[];
  grandTotal: number;
  grandDiscount: number;
  discountedGrandTotal: number;
  promoCodeDiscount?: number;
  promoCodeName?: string;
}


